import axios from 'axios';
import * as _ from 'lodash';
import { from, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';


import {
    IResponse,
    IUser,
    IUsersParams, IOrgUsersParams
} from '../models';

export default {
    // 获取人员列表
    getUsers(params: IUsersParams): Promise<IUser[]> {
        return axios.get<IUser[]>('/api/users', { params }).then(res => {
            return res.data;
        });
    },

    getUsersCount(params: IUsersParams): Promise<number> {
        return axios.get<number>('/api/users-count', { params }).then(res => {
            return res.data;
        });
    },

    // 获取组织下的人员列表
    getOrgUsers(params: IOrgUsersParams): Promise<IUser[]> {
        return axios.get<IUser[]>('/api/users/organizations/users', { params }).then(res => {
            return res.data;
        });
    },

    getOrgUsersCount(params: IOrgUsersParams): Promise<number> {
        return axios.get<number>('/api/users/organizations/users-count', { params }).then(res => {
            return res.data;
        });
    },

    getLatelyUsers(): Promise<IUser[]> {
        return axios.get<IUser[]>('/api/lately/users').then(res => {
            return res.data;
        });
    },

    saveLatelyUser(userId: string): Promise<IResponse> {
        return axios.post<IResponse>('/api/lately/users', { user_id: userId }).then(res => {
            return res.data;
        });
    },

    getUser(id: string): Promise<IUser> {
        return axios.get<IUser>('/api/users/' + id).then(res => {
            return res.data;
        });
    },

    addUser(command: IUser): Promise<any> {
        return axios.post<IUser>('/api/users/', command).then(res => {
            return res.data;
        });
    },

    updateUser(command: IUser): Promise<any> {
        return axios.put<IUser>('/api/users/', command).then(res => {
            return res.data;
        });
    },

    currentUser$: undefined,

    /* private */requestCurrentUserObservable(
        enforceNew?: boolean  // 强制获取最新数据，不取缓存
    ): Observable<IUser> {
        if (enforceNew || !this.currentUser$) {
            this.currentUser$ = from(  // Observable -> Promise
                axios.get<IUser>('/api/users/current').then(res => res.data)
            ).pipe(
                shareReplay(1)  // 多播
            );
        }
        return this.currentUser$;
    },

    // 获取当前用户
    getCurrentUser(enforceNew?: boolean): Promise<IUser> {
        return this.requestCurrentUserObservable(enforceNew).toPromise();
    },

    // 当前用户是否是系统管理员
    getCurrentUserIsSystemAdmin(enforceNew?: boolean): Promise<boolean> {
        return this.getCurrentUser(enforceNew).then(currentUser => {
            return _.includes(currentUser.roles, 'admin');
        });
    },

    // 用户学历列表
    getUserEducationsListSync(): string[] {
        return ['小学', '初中', '中专/高中', '专科', '本科', '硕士研究生', '博士研究生', '其他'];
    },

    // 添加角色
    addUserRole(command: { user_id: string, role: string }): Promise<IResponse> {
        return axios.post(`/api/users/${command.user_id}/roles`, command).then(res => {
            return res.data;
        });
    },

    // 删除角色
    deleteUserRole(userId: string, role: string): Promise<IResponse> {
        return axios.delete(`/api/users/${userId}/roles/${role}`).then(res => {
            return res.data;
        });
    },

    // 批量禁用/启用用户账号
    disableOrEnableUsers(command: { user_ids: string[], disabled: boolean }): Promise<any> {
        return axios.put(`/api/users/disable-users`, command).then(res => {
            return res.data;
        });
    }
}